import React from 'react';
import { TreeNodeType } from 'src/lib/types/types';
import VNDefaultProjektDaten from './content/VNDefaultProjektDaten';

export const VNTreeStructureProjektDaten = (_application: any) => {
	let treeNodes: TreeNodeType[] = [
		{
			label: 'Projektdaten',
			content: <VNDefaultProjektDaten />,
		},
	];

	return treeNodes;
};
